import { Component, Input, OnInit } from '@angular/core';
import { SellerNewsService } from 'src/app/shared/services/news/blog.service';

@Component({
  selector: 'app-news-block',
  templateUrl: './news-block.component.html',
  styleUrls: ['./news-block.component.scss'],
})
export class NewsBlockComponent implements OnInit {
  @Input() content;
  sellerNews: any;
  loading = false;

  constructor(private sellerNewsService: SellerNewsService) {}

  ngOnInit() {
    this.getSellerNews(this.content.company_id);
  }

  getSellerNews(id) {
    this.sellerNewsService
      .getSellerNews(id)
      .subscribe(result => (this.sellerNews = result.data))
      .add(() => (this.loading = false));
  }
}
